import { useCallback, useSyncExternalStore } from 'react';
import {
  getSystemTheme,
  getTheme,
  resolveTheme,
  setTheme,
  subscribe,
  type ResolvedTheme,
  type Theme,
} from '../lib/theme';

const serverTheme = (): Theme => 'system';
const serverSystemTheme = (): ResolvedTheme => 'light';

export interface UseThemeResult {
  /** The stored preference: 'light' | 'dark' | 'system'. */
  theme: Theme;
  /** The effective theme after resolving 'system'. */
  resolvedTheme: ResolvedTheme;
  setTheme: (theme: Theme) => void;
  /** Convenience helper for icon toggles. */
  toggle: () => void;
}

export function useTheme(): UseThemeResult {
  const theme = useSyncExternalStore(subscribe, getTheme, serverTheme);
  const systemTheme = useSyncExternalStore(subscribe, getSystemTheme, serverSystemTheme);
  const resolvedTheme = theme === 'system' ? systemTheme : theme;

  const update = useCallback((next: Theme) => setTheme(next), []);

  const toggle = useCallback(() => {
    setTheme(resolveTheme() === 'dark' ? 'light' : 'dark');
  }, []);

  return { theme, resolvedTheme, setTheme: update, toggle };
}
